import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {CONFIG} from "../../../app/config";
import {TAction} from "../../../app/enum";

import {DataService} from "../../../providers/data-service";

@Component({
    selector: 'page-showdesk',
    templateUrl: 'showdesk.html',
    providers: []
})

export class ShowdeskPage {

    bridgeOffline: any = false;
    bridgeOfflineTxt: string = '';

    config: any;
    logado: any;
    perfil: any;

    rootdata: any;
    hotspots: any[] = [];

    pageAtual: number = 0;
    pageCount: number = 0;
    itemsAmount: number = 0;
    itemsOffset: number = 0;

    showDeskIntervalTO: number = 0;
    bridgeOfflineCountI: number = 0;

    audioAlarme: any;
    audioAlarmeI: number;

    autoxScroll: boolean;

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public logadoService: LogadoService,
                public dataService: DataService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.perfil = this.logado;

        this.audioAlarme = new Audio('assets/sounds/alarme.mp3');
        this.autoxScroll = this.dataService.get('param.scroll');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Showdesk', '/showdesk');

        this.load(true);

    }

    ionViewDidLoad() {

        document.title = 'Showdesk';

    }

    load(isFirst = true) {

        let loading = this.util.loadingDots();
        if (isFirst) loading.present();

        this.logadoService.started(TAction.acDesk)
            .finally(() => {
                if (isFirst) loading.dismiss();
            })
            .subscribe(data => {

                this.rootdata = data;

                let heightItem = 50;
                let heightAvailable = 318;
                let heightWindow = window.innerHeight;
                this.itemsAmount = Math.floor((heightWindow - heightAvailable) / heightItem);
                this.pageCount = Math.ceil(this.rootdata.Hotspots.length / this.itemsAmount);

                if (this.autoxScroll) {

                    this.autoScroll();

                }
                else {

                    //Se veio zero Math.max 10.000 = 10s
                    let timeout = Math.max(this.config.request.showDeskInterval * (this.pageCount ? this.pageCount : 1), 10000);

                    this.hotspots = this.rootdata.Hotspots;
                    this.showDeskIntervalTO = setTimeout(() => this.load(false), timeout);

                }

                //this.startCounter();
                this.stopCounter();

            }, erro => {

                this.startCounter();
                this.showDeskIntervalTO = setTimeout(() => this.load(false), 10000);

            });

    }

    startCounter() {

        if (!this.bridgeOffline) {
            this.bridgeOffline = new Date();
            this.bridgeOffline.setSeconds(this.bridgeOffline.getSeconds() - (this.config.request.totalTimeout / 1000) - ((this.config.request.showDeskInterval / 1000) * this.pageCount));
        }

        this.bridgeOfflineCountI = setInterval(() => {

            let date = this.util.dateToStr(this.bridgeOffline, true);
            this.bridgeOfflineTxt = this.util.dateText(date, null, 'first');

        }, 1000);

        this.audioAlarmeI = setInterval(() => {

            this.audioAlarme.currentTime = 0;
            this.audioAlarme.play();

        }, 2000);

    }

    stopCounter() {

        this.bridgeOffline = false;

        this.bridgeOfflineCountI && clearInterval(this.bridgeOfflineCountI);

        if (this.audioAlarmeI) {
            this.audioAlarme.pause();
            clearInterval(this.audioAlarmeI);
        }

    }

    autoScroll() {

        this.hotspots = this.rootdata.Hotspots.slice(this.itemsOffset, this.itemsAmount + this.itemsOffset);

        this.showDeskIntervalTO = setTimeout(() => {

            this.pageAtual++;
            this.itemsOffset = this.pageAtual * this.itemsAmount;

            if (this.pageAtual < this.pageCount) {
                this.autoScroll();
            }
            else {
                this.pageAtual = 0;
                this.itemsOffset = 0;
                //this.load(false);
            }

        }, this.config.request.showDeskInterval);

    }

    fullScreen() {

        clearTimeout(this.showDeskIntervalTO);

        this.util.fullScreen();
        //setTimeout(() => this.load(), 1000);

    }

    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/show/showdesk/showdesk.ts